<template>
  <div class="logout pointer">
    <div class="logout--group flex__between" @click="setToggled">
      <div class="logout--img">{{ defaultAvatar }}</div>
      <div class="icon logout--icon" :class="iconClass">
        <font-awesome-icon icon="chevron-down" size="1x" />
      </div>
    </div>
    <div class="logout--menu" v-if="isToggled">
      <div class="icon user-menu--icon">
        <font-awesome-icon icon="caret-up" size="2x" />
      </div>
      <ul>
        <li @click="logOut" class="text__white">
          <font-awesome-icon icon="sign-out-alt" size="lg" />
          <span class="ml-10">Log Out</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      isToggled: false
    };
  },
  computed: {
    ...mapGetters(["getToggled", "getUser"]),
    iconClass() {
      return this.isToggled ? "logout--icon-flipped" : null;
    },
    defaultAvatar() {
      const names = this.getUser.username.split(" ");
      const first = names[0].split("")[0].toUpperCase();
      const last = names[names.length - 1].split("")[0].toUpperCase();
      return `${first} ${last}`;
    }
  },
  methods: {
    ...mapActions(["toggleMenu", "logOut"]),
    setToggled() {
      return (this.isToggled = !this.isToggled);
    }
  }
};
</script>

<style scoped lang="scss">
</style>